import { render, staticRenderFns } from "./GuideCard.vue?vue&type=template&id=0688af24&scoped=true&"
import script from "./GuideCard.vue?vue&type=script&lang=js&"
export * from "./GuideCard.vue?vue&type=script&lang=js&"
import style0 from "./GuideCard.vue?vue&type=style&index=0&id=0688af24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688af24",
  null
  
)

export default component.exports